import Link from 'next/link';
import React, { FC } from 'react';

import { getFilteredData } from '@/src/assets/helpers/getFilteredData';
import imageHelper from '@/src/assets/helpers/imageHelper';
import { ITheme } from '@/src/assets/interfaces/themeInterface';

import Button from '../../UI/button/Button';
import NextImage from '../../UI/nextImage/NextImage';
import NextLabel from '../../UI/nextLabel/NextLabel';
import { Title } from '../../UI/title/Title';
import Wrapper from '../../UI/wrapper/Wrapper';
import LatestCard from '../../latestCard/LatestCard';

import styles from './LatestSection.module.scss';

type TLatest = {
    featured: Partial<ITheme>;
    standartThemes: ITheme[];
};

const LatestSection: FC<TLatest> = ({ featured, standartThemes }) => {
    const slugsToShow = ['newsroom', 'persona'];
    return (
        <section className={styles.latest__section}>
            <Wrapper>
                {featured && (
                    <article className={styles.theme}>
                        <div className={styles.section__left}>
                            <NextLabel>Featured Theme</NextLabel>
                            <div className={styles.section__info}>
                                <Link
                                    href={`/themes/${featured.slug}`}
                                    className={`heading__3 ${styles.heading}`}>
                                    <Title text={featured.title!} size="md" />
                                </Link>
                                <p className={`excerpt ${styles.excerpt}`}>{featured.excerpt}</p>
                                <div className={styles.buttons}>
                                    <Button
                                        buttonUrl={`themes/${featured.slug}`}
                                        ariaLabel={`Explore ${featured.title}`}
                                        color="blue">
                                        Explore {featured.title}
                                    </Button>
                                    <Button
                                        ariaLabel="Explore All Themes"
                                        color="standard"
                                        className={styles.button}
                                        buttonUrl="/themes">
                                        Explore All Themes
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="18"
                                            height="18"
                                            viewBox="0 0 18 18"
                                            fill="none">
                                            <path
                                                d="M6.43674 5.19931L12.7123 5.28769M12.7123 5.28769L12.8007 11.5633M12.7123 5.28769L5.28769 12.7123"
                                                stroke="#0A163C"
                                                strokeWidth="1.7"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />
                                        </svg>
                                    </Button>
                                </div>
                            </div>
                        </div>

                        <Link href={`/themes/${featured.slug}`} className={styles.theme__right}>
                            <div className={styles.theme__mobile}>
                                <NextImage
                                    src={`${imageHelper(featured.themeMobile).url}`}
                                    alt="Spotlight mobile"
                                    fill
                                    sizes="
                                            (max-width: 475px) 25.15vw,
                                            (max-width: 576px) 20.12vw,
                                            (max-width: 640px) 18.3vw,
                                            (max-width: 820px) 19.7vw,
                                            (max-width: 900px) 12vw,
                                            (max-width: 1024px) 14vw, 
                                            (max-width: 1200px) 13.3vw, 
                                                                162px"
                                />
                            </div>
                            <div className={styles.theme__desktop}>
                                <NextImage
                                    src={`${imageHelper(featured.themeDesktop).url}`}
                                    alt="Spotlight desktop"
                                    fill
                                    sizes="
                                            (max-width: 475px) 68.55vw,
                                            (max-width: 576px) 67.1vw,
                                            (max-width: 640px) 49.5vw,
                                            (max-width: 820px) 53.5vw,
                                            (max-width: 900px) 35.2vw,
                                            (max-width: 1024px) 42.5vw, 
                                            (max-width: 1200px) 39vw, 
                                                                457px"
                                />
                            </div>
                        </Link>
                    </article>
                )}
                <ul className={styles.theme__cards}>
                    {standartThemes &&
                        getFilteredData(
                            standartThemes.filter((theme) => slugsToShow.includes(theme.slug)),
                            'latest'
                        ).map((theme, i) => {
                            return (
                                <li key={`${theme._id}+${i}`}>
                                    <LatestCard theme={theme} />
                                </li>
                            );
                        })}
                </ul>
            </Wrapper>
        </section>
    );
};

export default LatestSection;
